import React from "react";
import Proptypes from "prop-types";
import { IconButton, Tooltip } from "@material-ui/core";

export default function ToolbarItem(props) {
	const { Icon, title, handleClick } = props;

	return (
		<Tooltip title={title}>
			<IconButton onClick={handleClick}>{Icon}</IconButton>
		</Tooltip>
	);
}

ToolbarItem.propTypes = {
	Icon: Proptypes.object,
	title: Proptypes.string,
	handleClick: Proptypes.func
};
